var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarStorageIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21918",
    "data-name": "\\uADF8\\uB8F9 21918",
    transform: "translate(-730 -1380)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28340",
    "data-name": "\\uC0AC\\uAC01\\uD615 28340",
    width: 40,
    height: 40,
    transform: "translate(730 1380)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21917",
    "data-name": "\\uADF8\\uB8F9 21917",
    transform: "translate(37.524 0.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "enter",
    transform: "translate(696.59 1383.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10346",
    "data-name": "\\uD328\\uC2A4 10346",
    d: "M19.966,30.8a.877.877,0,0,0,0,1.252.846.846,0,0,0,1.2,0l3.705-3.705a1.725,1.725,0,0,0,.5-1.152,1.45,1.45,0,0,0-.5-1.152l-3.705-3.705a.885.885,0,0,0-1.252,1.252l2.9,2.9H10a.9.9,0,1,0,0,1.8H22.57Z",
    transform: "translate(0 -10.372)",
    fill: "#343a40",
    stroke: "#343a40",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10347",
    "data-name": "\\uD328\\uC2A4 10347",
    d: "M38.212,1.3H32.353a2.223,2.223,0,0,0-2.2,2.2V8.11a.9.9,0,1,0,1.8,0V3.453A.449.449,0,0,1,32.4,3h5.858a2.511,2.511,0,0,1,2.5,2.5V27.738a2.511,2.511,0,0,1-2.5,2.5H32.353a.449.449,0,0,1-.451-.451V25.185a.9.9,0,1,0-1.8,0v4.607a2.223,2.223,0,0,0,2.2,2.2h5.858a4.253,4.253,0,0,0,4.256-4.256V5.556A4.179,4.179,0,0,0,38.212,1.3Z",
    transform: "translate(-10.485)",
    fill: "#343a40",
    stroke: "#343a40",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1224",
    "data-name": "\\uD0C0\\uC6D0 1224",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(697.476 1397)",
    fill: "#ff6a13"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarStorageIcon2);
export default __webpack_public_path__ + "static/media/CarStorageIcon2.da08ee143dd4240475d6ff262ce1ec9c.svg";
export { ForwardRef as ReactComponent };